(function(root) {
  "use strict";

  const consent = root.LegitGrails.cookieConsent;
  const attributionKey = /^\$?(?:initial_)?(?:gclid|dclid|gbraid|wbraid|gad_source|gclsrc|fbclid|msclkid|ttclid|twclid|li_fat_id|sccid|rdt_cid|oppref|lg_clid|lg_clid_kind|lg_gcl|click_id|utm_.*|traffic_source)$/i;

  /**
   * Performance diagnostics need origin/path, never query, fragment or userinfo.
   * This recipient-specific policy is intentionally stricter than analytics URL
   * filtering. It never changes browser history, attribution or another payload.
   * @param {string} input
   * @returns {string}
   */
  function performanceUrl(input) {
    if (!input) return "";
    try {
      const url = new URL(String(input), root.location.href);
      if (url.protocol !== "https:" && url.protocol !== "http:") return "";
      url.search = "";
      url.hash = "";
      url.username = "";
      url.password = "";
      return url.href;
    } catch (error) {
      return "";
    }
  }

  /**
   * Clones SDK metadata and nested payloads before Faro can serialize them.
   * Also scrubs URLs embedded in messages/stacks and removes ad/attribution
   * fields. Cart/customer trace identifiers remain part of performance policy.
   * Cycles/deep unsupported payloads are omitted rather than bypassing filtering.
   * @param {*} input
   * @returns {*}
   */
  function performancePayload(input) {
    const ancestors = [];
    function clean(value, key, depth) {
      if (typeof value === "string") {
        if (/(?:url|uri|href|referrer|referer|location|filename|file_name)$/i.test(key || "") || /^\/[^\s]*$/.test(value)) {
          return performanceUrl(value);
        }
        return value.replace(/https?:\/\/[^\s<>"'\\]+/gi, performanceUrl);
      }
      if (!value || typeof value !== "object") return value;
      if (depth > 20 || ancestors.indexOf(value) !== -1) return null;
      if (value instanceof Date) return value.toISOString();
      ancestors.push(value);
      let result;
      if (Array.isArray(value)) {
        result = value.map(function(item) { return clean(item, key, depth + 1); });
      } else {
        result = {};
        Object.keys(value).forEach(function(name) {
          if (attributionKey.test(name) || name === "__proto__") return;
          result[name] = clean(value[name], name, depth + 1);
        });
      }
      ancestors.pop();
      return result;
    }
    return clean(input, "", 0);
  }

  consent.dataPolicy = {
    performanceUrl: performanceUrl,
    performancePayload: performancePayload
  };
})(window);
